module.exports = __webpack_public_path__ + "static/media/mercadotecnia.eeb9831b.jpg";